




























































































































import { Component, Emit, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'

@Component
export default class ComponentRecebimentoFiltros extends Vue {
  $refs: {
    menuDe: any,
    menuAte: any,
  }

  menuDe: boolean = false
  menuAte: boolean = false

  loadings: any = {
    getPrestadores: false,
    getProfissionaisExecutantes: false,
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  async mounted() {
    await this.getRecebimentoStore.getFontePagadoraLoggedUser()
  }

  get anoMesReferenciaDe() {
    return this.getRecebimentoStore.anoMesReferenciaDeSelected
  }

  set anoMesReferenciaDe(value) {
    this.getRecebimentoStore.setAnoMesReferenciaDeSelected(value)
  }

  get anoMesReferenciaAte() {
    return this.getRecebimentoStore.anoMesReferenciaAteSelected
  }

  set anoMesReferenciaAte(value) {
    this.getRecebimentoStore.setAnoMesReferenciaAteSelected(value)
  }

  get fontesPagadoras() {
    return this.getRecebimentoStore.fontePagadoras
  }

  get fontePagadora() {
    return this.getRecebimentoStore.fontePagadoraSelected
  }

  set fontePagadora(newValue: any) {
    this.getRecebimentoStore.setFontePagadoraSelected(newValue)
  }

  selectSituacao(data: any) {
    this.getRecebimentoStore.setFontePagadoraSelected(data)
  }

  resetForm() {
    this.getRecebimentoStore.clearFiltroRecebimento()
    this.getRelatorio()
  }

  @Emit('getRelatorio')
  getRelatorio() {}
}
